var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import ReactDOM from 'react-dom';
import { FullscreenYoutube } from '../components/FullscreenYoutube';
import { set as cookieSet } from 'js-cookie';
import { API, MAIN_BACKEND_URL } from '../data/API';
import styled from 'styled-components';
import { Modal } from '../components/Modal';
import { Analytics } from '../data/Analytics';
const windowHelper = window;
function isConsentGiven(preference) {
    const consent = Shopify.customerPrivacy.currentVisitorConsent();
    const validKeys = ["marketing", "analytics", "preferences", "sale_of_data"];
    // Check if the provided preference is a valid key
    if (!validKeys.includes(preference)) {
        console.error(`Invalid consent value: ${preference}`);
        return false;
    }
    return consent[preference] === "yes";
}
windowHelper.isConsentGiven = isConsentGiven;
class VitalLibrary {
    constructor() {
        this.modal = Modal;
        this.analytics = Analytics;
    }
    openApparelSizeModal(imageUrl) {
        Modal.open('', React.createElement("img", { src: imageUrl, className: 'my-2 w-full max-w-375px lg:my-12 lg:mx-16' }), '');
    }
    openYoutubeVideo(videoId) {
        let youtubeVideoComponent = document.getElementById('fullscreen-youtube');
        if (!youtubeVideoComponent) {
            youtubeVideoComponent = document.createElement('div');
            youtubeVideoComponent.id = 'fullscreen-youtube';
            document.body.append(youtubeVideoComponent);
        }
        ReactDOM.render(React.createElement(FullscreenYoutube, { videoId: videoId, visible: true }), youtubeVideoComponent);
    }
    closeYoutubeVideo() {
        const youtubeVideoComponent = document.getElementById('fullscreen-youtube');
        if (youtubeVideoComponent) {
            ReactDOM.render(React.createElement(FullscreenYoutube, { visible: false }), youtubeVideoComponent);
        }
    }
    createElement(tagName, ...classNames) {
        const element = document.createElement(tagName);
        element.classList.add(...classNames);
        return element;
    }
    appendShadowDom(parent) {
        const child = this.createElement('div');
        parent.append(child);
        return child.attachShadow({ mode: 'open' });
    }
    /**
     * Determines weather a variant is sku rationalized
     * @param variantId The Product Variant Id
     * @param action The action to take if in a product card
     * @returns Boolean Returns true if product variant is rationalized
     */
    isRationlized(variantId, action = '') {
        const isRationlized = windowHelper.vitalData.skusRationalized &&
            windowHelper.vitalData.skusRationalized.find(item => item.variantId === String(variantId))
            ? true
            : false;
        return ((action.toLowerCase() === 'reactivate' || action.toLowerCase() === '') &&
            isRationlized);
    }
    validatePhone(phone) {
        var phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im;
        return phoneRegex.test(phone);
    }
    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    /**
     * Subscriber Signup Page
     * @param form The form
     */
    onSubscriberSignup(form, mask) {
        const email = form.email.value;
        const phone = mask && mask.unmaskedValue ? mask.unmaskedValue : form.phone.value;
        const smsOptIn = form.smsOptIn.checked;
        const emailOptIn = form.emailOptIn.checked;
        if (smsOptIn && !phone) {
            return Promise.reject('To Opt in to SMS please add a phone number.');
        }
        if (emailOptIn && !email) {
            return Promise.reject('To Opt in to email communications please add a valid email.');
        }
        const data = {
            email: email,
            phone: phone,
            'sms_consent': smsOptIn.toString(),
            'email_consent': emailOptIn.toString(),
        };
        if (!email && !phone) {
            return Promise.reject("An email or phone number is required to subscribe.");
        }
        let result = fetch(`${this.getMainBackendUrl()}/subscriber/add`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(res => {
            if (!res.ok) {
                throw new Error(res.statusText);
            }
            return res;
        })
            .then(res => res.json())
            .then(res => {
            form.reset();
            return res;
        })
            .catch(err => {
            console.error(err);
            return Promise.reject("Service unavailable. Please try again later.");
        });
        console.log(result);
        return Promise.resolve(result);
    }
    getMainBackendUrl() {
        return MAIN_BACKEND_URL;
    }
    sendQuizResultsToKlaviyo(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield API.Backend.saveContactFromQuiz(data);
            }
            catch (e) {
                console.log(e);
            }
        });
    }
}
const copyToClipboard = (text) => {
    let dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
};
windowHelper.vitalLibrary = new VitalLibrary();
//region Adds analytics listeners
//GA
const GAListener = {
    track: (category, action, label, value, extraData) => {
        if (isConsentGiven('analytics')) {
            windowHelper.ga('send', {
                hitType: 'event',
                eventCategory: category,
                eventAction: action,
                eventLabel: label,
                eventValue: value,
            });
        }
    },
    identify: (email, id, ltv, orderCount) => { },
};
windowHelper.vitalLibrary.analytics.addEventListener(GAListener);
//TikTok
const TikTokListener = {
    track: (category, action, label, value, extraData) => {
        if (isConsentGiven('analytics')) {
            windowHelper.ttq.track(category, { action, label, value, extraData });
        }
    },
    identify: (email, id, ltv, orderCount) => {
        if (isConsentGiven('analytics')) {
            windowHelper.ttq.identify({ external_id: id, email });
        }
    },
};
windowHelper.vitalLibrary.analytics.addEventListener(TikTokListener);
//endregion
if (windowHelper.ShopifyConstants &&
    windowHelper.ShopifyConstants.bundleAssetUrl)
    cookieSet('bundleAssetUrl', windowHelper.ShopifyConstants.bundleAssetUrl, {
        expires: 365,
        domain: 'vitalproteins.com',
    });
if (windowHelper.ShopifyConstants && windowHelper.ShopifyConstants.vitalLibraryAssetUrl) {
    cookieSet('vitalLibraryAssetUrl', windowHelper.ShopifyConstants.vitalLibraryAssetUrl, {
        expires: 365,
        domain: 'vitalproteins.com'
    });
}
if (windowHelper.ShopifyConstants &&
    windowHelper.ShopifyConstants.tailwindAssetUrl)
    cookieSet('tailwindAssetUrl', windowHelper.ShopifyConstants.tailwindAssetUrl, { expires: 365, domain: 'vitalproteins.com' });
const VitalShield = styled.img `
  width: 100%;
  height: 51px;
  object-fit: contain;
  margin-bottom: 20px;
`;
const ModalDescription = styled.div `
  font-family: AvenirNext, Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.583333px;
  color: #393d40;
  margin-top: 30px;
  margin-bottom: 30px;
`;
const ModalTitle = styled.div `
  font-family: KapraNeue, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 35px;
  text-align: center;
  letter-spacing: 0.9625px;
  text-transform: uppercase;
  color: #393d40;
`;
